module.exports = __webpack_public_path__ + "static/media/sun.39557727.svg";